export default __webpack_public_path__ + "static/media/nikotan.e158d713.png";